const {registerModule} = window;

/**
 * AutoScroll module
 * Sets the scroll speed for autoscrolling elements to be constant regardless of width
 * @param {HTMLElement} element feature list section selector
 */

class AutoScroll {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();

    if (this.ui.$scrollables.length > 0) {
      this.setScrollSpeed();
    }
  }

  bindUI() {
    this.ui = {};
    this.ui.$scrollables = [
      ...this.element.querySelectorAll('.notificationBanner__text-inner'),
      ...this.element.querySelectorAll('.logo-cloud__images'),
    ];
  }

  setScrollSpeed() {
    this.ui.$scrollables.forEach(($scrollable) => {
      $scrollable.style.animationDuration = `${$scrollable.offsetWidth / 30}s`;
    });
  }
}

registerModule('AutoScroll', AutoScroll);


